export default {
  enter_pin_message: "Enter the 6-digit code sent to your email.",
  enter_pin_message_phone: "Enter the 6-digit code sent to your phone.",
  validateMsg: {
    apiError: {
      offline:
        "You're offline. Please reconnect to the internet and try again.",
    },
    firmware: {
      version: "Please enter firmware version.",
      duplicateVersion: "The version you entered already exists.",
      file: "Please upload firmware file.",
      releaseNote: "Please enter release note.",
    },
    signup: {
      orgName: "Please enter a valid company name.",
      reseller: {
        "1024":
          "This email has already been sent with an invitation.\nPlease check your mailbox again or contact your organization's administrator if you would like to receive the invitation email again.",
      },
      resellerSubmissionFail: "Reseller submission failed.",
      resellerSignupFail: "Reseller signup failed.",
      companyName: "Company name cannot be blank.",
      "30001": "Payload validation error",
      "30002": "Invalid token",
      "30003": "Insufficient scope",
      "30004": "Rate limit exceeded",
      "30005": "An internal error occurred",
      "30006": "Password has previously been used",
      "30007": "User not found",
      "30100": "There was an error processing the password reset.",
      defaultError: "An error occurred. Please try again later.",
      accountNotFound: "Organization does not exist.",
      loginIncorrect: "Incorrect login credentials.",
      firstname: "Please enter your first name.",
      lastname: "Please enter your last name.",
      passwordMismatch: "The password you entered does not match.",
      password: {
        empty: "Password cannot be blank.",
        short: "Password must be at least 8 characters.",
        NotContainUppercase:
          "Password must contain both lowercase and uppercase letters.",
        NotContainSpecial:
          "Password must contain one or more numeric and special characters.",
      },
      disActivateUser: "Please accept the signup invite sent to this address",
      reSetPassword: {
        notRequired: "Your new password doesn’t meet the required criteria.",
      },
      phone: {
        invalidFormat: "The phone number you entered is in an invalid format.",
        cantBe2fa: "You must enter a phone number when use 2FA code.",
        empty: "Phone number is required.",
      },
      agreement: "Please review the user agreement.",
      verifyNumber: "The code you entered does not match.",
      requiredVerifyNumber: "Please verify your phone number.",
      fail: "Sign-up failed during the registration process.",
      getTokenEmail: "Please contact your administrator.",
      getTokenExpire:
        "Invitation has expired. Please contact your administrator.",
      getTokenInvalid:
        "Invitation is invalid. Please contact your administrator.",
      requiredVerifyCode: "Please enter the verification code.",
      invalidPhoneNumber: "Sending of the verification message failed.",
      noUserInformation: "User information was not found.",
      invalidEmail: "Invalid email address",
      noExistPhone: "Phone number entered not found in the system.",
      noExistEmail: "Email does not exist",
      email: {
        difference: "Invitation email does not match authenticated email.",
      },
      checkEmail: {
        cloudUser: "Use the DW Spectrum Web Login button to log in to myDW",
        noExist: "The email address entered is not registered",
      },
    },
    reset: {
      fail: "Password reset unsuccessful",
      getTokenExpire: "The reset token has expired.\n Please retry again.",
      getTokenInvalid:
        "The reset token is invalid. Please contact your administrator.",
    },
    freeTrial: {
      "1024":
        "This email has already been sent with an invitation.\nPlease check your mailbox again or contact your organization's administrator if you would like to receive the invitation email again.",
    },
    profile: {
      address: {
        empty: "Address cannot be blank.",
      },
      email: {
        empty: "Please enter email.",
        irregular: "Enter a valid email address.",
      },
      phone: {
        empty: "Please enter phone number.",
        same: "New phone number cannot be same as the one used previously.",
        validate: "Please try again with the correct format.",
        verify: {
          code: "The verification code has not been confirmed.",
          fail: "Your phone number has not been verified.",
        },
      },
      passwordEmpty: "Please enter current password.",
      newPasswordEmpty: "Please enter new password.",
      description: "Please do not exceed 255 characters.",
      passwordSame: "New password cannot be same as the one used previously.",
    },
    login: {
      password: {
        incorrect: "You entered an incorrect password",
      },
      DWCloudUserNotRegistered:
        "Your DW Spectrum Cloud account is not linked to a myDW organization. Please accept the myDW invitation or contact your administrator.",
    },
    information: {
      updateError: "Information update failed",
      updateSuccess: "Information updated successfully",
      requiredEmpty: "Please fill in all required fields",
      invalidValue: "Please enter a valid value",
      maxLength: "The maximum number of items is 10",
      invalidURL: "Please enter a valid URL",
      invalidPhone: "Please enter a valid phone number",
    },
    account: {
      empty: "Organization name cannot be blank.",
      userMail: {
        same: "Your email is already part of this organization.",
        empty: "Email address is required.",
      },
      generateId: {
        fail: "Failed to generate organization number",
      },
      delete: {
        fail: "Failed to delete organization.",
        success: "Organization deleted successfully.",
      },
      create: {
        fail: "Failed to add organization.",
        success: "Organization added successfully.",
      },
      modify: {
        fail: "Failed to update organization.",
        success: "Organization updated successfully.",
      },
      name: "Please enter organization name.",
      nameInvalid:
        "Organization name must be 3-100 characters, include at least one alphabet character, and use only allowed characters.",
      level: "Organization level is mandatory.",
      discount: {
        empty: "If Custom is selected, a discount must be entered.",
      },
      permissionsDeny:
        "The organization needs permissions. Please contact your administrator.",
      transfer: {
        "3011": "The organization for transfer does not exist.",
        "3012": "You are not an administrator of the target organization.",
        "3013": "You are not an administrator of the destination organization.",
        "3014": "Transferring to another EU organization is not allowed.",
        "3015": "Transferring to another Sub CP organization is not allowed.",
        "3016": "Transferring to another DW organization is not allowed.",
        "3017":
          "Transfer is not allowed because Sub CPs exist under this organization.",
        "3018": "Transfers to the same organization are not allowed.",
        "3019": "The organization has been disabled.",
        "3020": "The organization has been suspended.",
        fail: "Failed to transfer organization.",
        success: "Transferred organization successfully.",
      },
      keepAccount: {
        fail: "Failed to keep installer account.",
        success: "Keep installer account successfully.",
      },
      removeAccount: {
        fail: "Failed to remove installer account.",
        success: "Remove installer account successfully.",
      },
      invite: {
        fail: "Failed to invite owner.",
        success: "Invitation request sent successfully.",
      },
      switch: {
        max: "You’ve reached the maximum of 8 favorite organizations.",
      },
      access: {
        temporary: {
          success: "Success to request temporary access.",
          fail: "Failed to request temporary access.",
          validateMsg: {
            recipient: "Please select a recipient admin user.",
            duration: "Please select a duration.",
          },
        },
      },
    },
    user: {
      name: "Please enter user name.",
      email: "Enter a valid email address",
      group: {
        name: {
          empty: "Please enter group name.",
          exist: "Group name already exists.",
        },
        fail: "Failed to add group.",
        selected: "A User Group must be selected.",
      },
    },
    userGroup: {
      userPermission: "Please select one or more myDW Permissions.",
      recorder: "Please select one or more recorders.",
      sameDefault:
        "Administrator, Manager, and Viewer group names are not allowed as they already exist.",
      emptyAdmin: "Select one or more users.",
    },
    recorder: {
      emptyAddress: "Please enter the address of the recorder.",
    },
    recorderGroup: {
      name: "Please enter recorder group name.",
    },
    alert: {
      view: {
        emptyAssignMessage:
          "Enter a message to send to the assigned technician",
      },
      rule: {
        emptyAccount: "Please select one or more organizations.",
        emptyRuleName: "Please enter alert rule name.",
        emptyRule: "Please turn on one or more rules.",
      },
    },
    report: {
      rule: {
        emptySingleAccount: "Please select one organization.",
        emptyCamera: "Please select one or more cameras.",
        emptyRuleName: "Please enter report rule name.",
        emptySingleRecorder: "Please select one recorder.",
        emptyCustomName: "Please enter customer name.",
        emptyCustomPhone: "Please enter customer phone number.",
        emptyCustomAddress: "Please enter customer address.",
        emptyInstallName: "Please enter installer name.",
        emptyInstallPhone: "Please enter installer phone number.",
        emptyTitle: "Please enter title.",
      },
    },
    videoShare: {
      err: {
        uploadSuccess: "Video Share upload successfully.",
        uploadFail: "Video Share upload failed.",
        emptyUser: "Select one or more users or enter email address.",
        invalidEmail: "The entered email is invalid.",
        invalidVideoId: "Video information is invalid.",
      },
    },
    notice: {
      title: "Please enter notice title.",
      message: {
        empty: "Please enter notice message.",
        exceed: "Please do not exceed 500 characters.",
      },
    },
    help: {
      about: {
        emptyIssue: "Please enter issue details.",
        success: "Issue reported successfully.",
        fail: "Failed to report issue.",
      },
      utility: {
        admin: {
          generate: {
            success: "OTP generated successfully.",
            fail: "Failed to generate OTP.",
          },
          macAddress: {
            empty: "Please enter a MAC address.",
            valid: "Please enter a valid MAC address.",
          },
          time: {
            empty: "Please enter a time.",
            valid: "Please enter a valid time.",
          },
        },
      },
    },
    setting: {
      email: {
        title: {
          empty: "Please enter an email subject.",
        },
        message: {
          empty: "Please enter a message.",
        },
        scheduleTime: {
          empty: "Please enter a send date / time.",
        },
      },
    },
    manager: {
      video: {
        url: "The URL you entered is in an invalid format.",
        file: "Please upload a file.",
        thumbnail: "Please click the thumbnail button to get a thumbnail.",
      },
    },
  },
  label: {
    releaseNotes: {
      add: {
        success: "Release note added successfully.",
        fail: "Failed to add release note.",
      },
      update: {
        success: "Release note updated successfully.",
        fail: "Failed to update release note.",
      },
      delete: {
        success: "Release note deleted successfully.",
        fail: "Failed to delete release note.",
      },
    },
    login: {
      forgotEmail: {
        resend: {
          sms: "Email reminder was sent successfully.",
        },
      },
    },
    signup: {
      resendCode: {
        success: "Verification code sent successfully.",
        fail: "Failed to send verification code.",
      },
    },
    lyve: {
      notify: {
        update: {
          fail: "Failed to update storage size.",
          success: "Storage Size updated successfully.",
        },
      },
      generateKey: {
        fail: {
          "70004": "CPP must be three or more digits.",
          "70005": "CPP may not start with 0.",
          "70006": "CPP must only be digits.",
          "70007": "The CPP number is unavailable.",
          "70008": "Creating CPP is failed.",
          default: "Failed to generate key.",
        },
        cpp: {
          fail: "CPP Number must be greater than 100",
          required: "CPP Number is required",
        },
        partNumber: {
          required: "Part Number is required",
          same: "Part Number is already in use",
        },
      },
    },
    features: {
      list: {
        fail: "Failed to get features popup list",
      },
      notify: {
        delete: {
          success: "Features popup deleted successfully",
          fail: "Failed to delete features popup",
        },
        add: {
          success: "Features popup added successfully",
          fail: "Failed to add features popup",
        },
        update: {
          success: "Features popup updated successfully",
          fail: "Failed to update features popup",
        },
      },
      error: {
        "20001": "AWS communication failure.",
        "50006": "Files does not contain file_name.",
        "50007": "Announcement is not found.",
        "50008": "Announcement Slide Image is not found.",
        "50009": "Upload file is not image type.",
        "50010":
          "The Display Pop-up cannot be set to ON because the scheduled time has already passed.",
      },
    },
    email: {
      notify: {
        update: {
          success: "Email updated successfully.",
          fail: "Email update failed.",
        },
      },
    },
    manager: {
      video: {
        create: {
          success: "Video added successfully.",
          fail: "Failed to add video.",
        },
        modify: {
          success: "Video updated successfully.",
          fail: "Failed to update video.",
        },
        delete: {
          success: "Video deleted successfully.",
          fail: "Failed to delete video.",
        },
        group: {
          create: {
            success: "Video group added successfully.",
            fail: "Failed to add video group.",
          },
          modify: {
            success: "Video group updated successfully.",
            fail: "Failed to update video group.",
          },
          delete: {
            success: "Video group deleted successfully.",
            fail: "Failed to delete video group.",
          },
        },
      },
      file: {
        create: {
          success: "File added successfully.",
          fail: "Failed to add file.",
        },
      },
      tech: {
        modify: {
          success: "Tech report updated successfully.",
          fail: "Failed to modify tech report.",
        },
      },
    },
    org: {
      notAvailable: "Organization is no longer available.",
    },
    autoApply: {
      recorder: "Apply to all current and future recorders.",
    },
    select: {
      usersGroups: "Add User Groups",
      account: "Add Organizations",
      recorder: "Add Recorders",
      recorderGroup: "Add Recorder Groups",
      verification: "CVV",
      schedule: "Schedule",
    },
    recorder: {
      tooltip: {
        alert: {
          instruction: "Click here for instructions to clear this alert.",
        },
      },
      notify: {
        transfer: {
          success: "Recorder assigned successfully.",
          fail: "Failed to assign recorder. Please try again later.",
        },
        thumbnail: {
          type: {
            error: "Only PNG or JPG files can be uploaded.",
          },
          upload: {
            error: "Failed to upload custom thumbnail.",
          },
        },
        mergedSystem: {
          update: {
            success: "Merged system updated successfully.",
            fail: "Failed to update merged system.",
          },
        },
        search: {
          error: "Registered recorder not found.",
        },
        update: {
          success: "Recorder updated successfully.",
          fail: "Failed to update recorder.",
        },
        delete: {
          success: "Recorder deleted successfully.",
          fail: "Failed to delete recorder.",
        },
        connection: {
          fail: "Failed to save connection information.",
        },
        connectionTest: {
          success: "The connection test was successful.",
          fail: "The connection test failed.",
        },
        deRegistration: {
          success: "System deleted successfully.",
          fail: "Failed to delete system.",
        },
      },
    },
    recorderGroup: {
      notify: {
        create: {
          success: "Recorder group added successfully.",
          fail: "Failed to add recorder group.",
        },
        delete: {
          success: "Recorder group deleted successfully.",
          fail: "Failed to delete recorder group.",
        },
        update: {
          success: "Recorder group updated successfully.",
          fail: "Failed to update recorder group.",
        },
      },
    },
    alertRule: {
      notify: {
        create: {
          fail: "Alert rule creation failed.",
        },
        getDetail: {
          fail: "Alert rule search error.",
        },
        add: {
          success: "Alert rule added successfully.",
          fail: "Alert rule failed to be added.",
        },
        update: {
          success: "Alert rule updated successfully.",
          fail: "Alert rule update failed.",
        },
        delete: {
          success: "Alert rule deleted successfully.",
          fail: "Alert rule deletion failed.",
        },
      },
      tooltip: {
        recorderNotResponse: "Recorder is down or offline.",
        abnormal: "Number of abnormal restarts in the last 24 hours.",
        systemOverheat: "[VMAX Only] System temperature over 70",
        hardwareFailure:
          "[Only VMAX and COVA] Disk error or HDD S.M.A.R.T error detected.",
        diskOverheat: "[VMAX Only] Disk temperature over 70",
        badSector: "[VMAX Only] Percentage of bad sectors.",
        storageStatus:
          "[Spectrum Only] One or more storage devices are being checked by media server.",
        reIndex:
          "[Spectrum Only] Recorder is reindexing of one or more storage devices.",
        storageFull: "[Spectrum Only] Free space on the disk is below 20 GB.",
        reserveSpace:
          "[Spectrum Only] Reserved space on the disk exceeds 110% of free space.",
        loss: "Camera is offline or unauthorized.",
        notRecording: "The Recording software may be malfunctioning",
      },
    },
    alertHistory: {
      notify: {
        search: {
          fail: "Alert history search error.",
        },
        subSystem: {
          fail: "Could not search recorder",
        },
      },
    },
    report: {
      notify: {
        list: {
          search: {
            fail: "Failed to search report list.",
          },
        },
        cvv: {
          delete: {
            success: "CVV report deleted successfully.",
            fail: "Failed to delete CVV report.",
          },
          create: {
            success: "CVV report created successfully.",
            fail: "Failed to create CVV report.",
          },
          update: {
            success: "CVV report updated successfully.",
            fail: "Failed to update CVV report.",
            "90005": "Failed to update the reference thumbnail.",
          },
          list: {
            error: "CVV search error.",
          },
          refer: {
            camera: {
              success: "Camera reference updated successfully.",
              fail: "No thumbnail available to update.",
            },
            recorder: {
              success: "Recorder reference updated successfully.",
            },
          },
          checknow: {
            success: "Camera checked successfully.",
          },
        },
        cp: {
          delete: {
            success: "CP report deleted successfully.",
            fail: "Failed to delete CP report.",
          },
          create: {
            success: "CP report created successfully.",
            fail: "Failed to create CP report.",
          },
          update: {
            success: "CP report updated successfully.",
            fail: "Failed to update CP report.",
          },
        },
        health: {
          delete: {
            success: "Health report deleted successfully.",
            fail: "Failed to delete Health report.",
          },
          create: {
            success: "Health report created successfully.",
            fail: "Failed to create Health report.",
          },
          update: {
            success: "Health report updated successfully.",
            fail: "Failed to update Health report.",
          },
          list: {
            error: "Health search error.",
          },
        },
        install: {
          delete: {
            success: "Installation report deleted successfully.",
            fail: "Failed to delete Installation report.",
          },
          create: {
            success: "Installation report created successfully.",
            fail: "Failed to create Installation report.",
          },
          update: {
            success: "Installation report updated successfully.",
            fail: "Failed to update Installation report.",
            complete: {
              success: "Report marked as completed.",
              fail: "Failed to update the report as completed.",
            },
          },
          emailSend: {
            success: "The report email sent successfully.",
            fail: "Failed to send Installation report.",
          },
          sync: {
            success: "Start thumbnail synchronization.",
            fail: "Failed to sync thumbnail.",
            end: "The thumbnail synchronization process completed successfully.",
          },
        },
        inventory: {
          download: {
            config: {
              error: "Failed to download configuration.",
            },
          },
          delete: {
            success: "Inventory report deleted successfully.",
            fail: "Failed to delete Inventory report.",
          },
          create: {
            success: "Inventory report created successfully.",
            fail: "Failed to create Inventory report.",
          },
          update: {
            success: "Inventory report updated successfully.",
            fail: "Failed to update Inventory report.",
          },
        },
        thumbnail: {
          delete: {
            success: "Thumbnail report deleted successfully.",
            fail: "Failed to delete Thumbnail report.",
          },
          create: {
            success: "Thumbnail report created successfully.",
            fail: "Failed to create Thumbnail report.",
          },
          update: {
            success: "Thumbnail report updated successfully.",
            fail: "Failed to update Thumbnail report.",
          },
          list: {
            error: "Thumbnail search error.",
          },
        },
      },
      send: {
        email: {
          placeholder:
            "Click to select a user or enter an email address to send this report.",
        },
      },
    },
    common: {
      notify: {
        email: {
          success: "Email sent successfully.",
        },
        message: {
          success: "Message sent successfully.",
          fail: "Message sending failed.",
        },
      },
    },
    user: {
      group: {
        notify: {
          add: {
            success: "User group added successfully.",
            fail: "Failed to add User group.",
          },
          update: {
            success: "User group updated successfully.",
            fail: "Failed to update user group.",
          },
          delete: {
            success: "User group deleted successfully.",
            fail: "Failed to delete User group.",
          },
        },
      },
      notify: {
        resend: {
          success: "Invite email sent successfully.",
          fail: "Failed to send invite email.",
        },
        list: {
          fail: "User search error.",
        },
        delete: {
          success: "User removed successfully.",
          fail: "Failed to delete user.",
        },
        add: {
          success: "User added successfully.",
          fail: "Failed to add user.",
        },
        update: {
          success: "User updated successfully.",
          fail: "Failed to update user.",
        },
      },
    },
    userGroup: {
      notify: {
        list: {
          fail: "User group search error.",
        },
        delete: {
          fail: "Failed to delete user group.",
        },
        add: {
          fail: "Failed to add user group.",
        },
      },
    },
    videoshare: {
      notify: {
        share: {
          success: "Video shared successfully.",
          fail: "Failed to share video.",
          update: {
            success: "Video share updated successfully.",
            fail: "Failed to update video share.",
          },
        },
        commentAdd: {
          success: "Comment added successfully.",
          fail: "Failed to add comment.",
        },
        commentDel: {
          fail: "Failed to delete comment.",
        },
        save: {
          success: "Video share information updated successfully.",
          fail: "Failed to update video share information.",
        },
        search: {
          error: "Video share search error.",
        },
        delete: {
          success: "Video share deleted successfully.",
          fail: "Failed to delete video share.",
        },
        maxComment: "Your comment cannot exceed 250 characters.",
        user: {
          update: {
            success: "Shared information updated successfully.",
            fail: "Failed to update shared information.",
          },
          delete: {
            success: "Shared user deleted successfully.",
            fail: "Failed to delete Shared user.",
          },
        },
      },
      guest: {
        verification: {
          sendCode: {
            desc: "For Security reasons, myDW required an email verification to access shared videos. Click the button below to send a verification code to",
            expired: "The link you followed has expired.",
          },
        },
        verify: {
          resend: {
            success: "Success to resend code.",
          },
        },
        default: {
          error: "Failed to get Video Share.",
        },
      },
    },
    alert: {
      notify: {
        list: {
          error: "Error while searching for alert",
        },
        assigned: {
          success: "User assigned successfully.",
        },
        assign: {
          fail: "Failed to assign user",
        },
        commentDel: {
          success: "Comment deleted successfully.",
        },
        status: {
          success: "Alert closed successfully.",
          fail: "Failed to close status.",
        },
        allClose: {
          success: "All statuses were successfully closed",
          fail: "Failed to close all statuses.",
        },
      },
    },
    profile: {
      notify: {
        image: {
          over: {
            error: "The size of the image is larger than recommended",
          },
        },
        updateImage: {
          fail: "Failed to upload profile image.",
        },
        delImage: {
          success: "Profile image deleted successfully.",
          fail: "Failed to delete profile image.",
        },
        update: {
          success: "Profile updated successfully.",
          fail: "Failed to update profile.",
        },
        deactivate: {
          fail: "Failed to deactivate profile.",
        },
        user: {
          no: "User info not found.",
        },
        search: {
          fail: "User Profile Information not available.",
        },
        theme: {
          fail: "Theme not available.",
        },
      },
    },
    billing: {
      notify: {
        update: {
          success: "Organization suspension updated successfully.",
          fail: "Failed to update organization suspension.",
        },
        check: {
          suspend: {
            title: "Do you really want to suspend this organization?",
            subTitle: "Associated organization will also be suspended.",
          },
          reactivate: {
            title: "Do you really want to reactivate this organization?",
            subTitle: "Associated organization will also be reactivated.",
          },
        },
      },
    },
    subscription: {
      send: {
        email: {
          placeholder:
            "Click to select a user or enter an email address to send subscription info to.",
        },
      },
      generate: {
        essential: {
          validate: "Please enter all required information.",
        },
        checkout: {
          fail: "Failed to subscribe. Please check your information.",
        },
        keys: {
          fail: "Failed to generate keys.",
        },
      },
      key: {
        essential: {
          validate: "Please enter at least 1.",
        },
        format: {
          error:
            "Please enter a key in the correct format. (1XXXX-XXXX-XXXX-XXXX)",
        },
      },
      keyType: {
        essential: {
          validate: "Please select the type of the subscription keys.",
        },
      },
      duration: {
        essential: {
          validate: "Please select duration.",
        },
      },
      checkout: {
        fail: "Failed to checkout keys.",
      },
      register: {
        success: "Keys registered successfully.",
        fail: "Failed to register keys.",
        empty: "Please enter at least one key.",
        file: {
          empty: "The uploaded file does not contain any keys.",
        },
      },
      activate: {
        key: {
          empty: "Enter a subscription key to activate.",
        },
        fail: "Failed to activate subscription key.",
        success: "Subscription key activated successfully.",
      },
      check: {
        activate: {
          fail: "Failed to check subscription key.",
        },
      },
      request: {
        success: "Subscription key request sent succesfully.",
        fail: "Failed to request subscription key.",
      },
      get: {
        keyType: {
          fail: "Failed to get subscription key type.",
        },
        keyPrice: {
          fail: "Failed to get subscription key price.",
        },
      },
      confirm: {
        success: "Key confirmed successfully.",
        fail: "Failed to confirm key.",
      },
      service: {
        get: {
          fail: "Failed to get services & pricing.",
        },
        update: {
          fail: "Failed to update services & pricing.",
          success: "Services & pricing updated successfully.",
        },
      },
      replace: {
        success: "Key replaced successfully.",
        fail: "Failed to replace key.",
      },
      export: {
        fail: "Failed to export keys.",
        noData: "No key data to export.",
        summary: {
          fail: "Failed to export detail info.",
        },
      },
      detail: {
        summary: {
          fail: "Failed to get detail info.",
        },
      },
      cova: {
        renew: {
          success: "Free key renewed successfully.",
          fail: "Failed to renew free key.",
        },
        reset: {
          success: "Expiration date updated successfully.",
          fail: "Failed to update expiration date.",
        },
      },
      org: {
        list: {
          fail: "Failed to get subscription organization list.",
        },
      },
      sendEmail: {
        empty: "Please enter a message",
        title: {
          empty: "Please enter a title",
        },
      },
    },
    link: {
      notify: {
        token: {
          error: "Failed to find your connection information.",
        },
      },
    },
    setting: {
      firmware: {
        notify: {
          add: {
            success: "Firmware added successfully.",
            fail: "Failed to add firmware.",
            file: {
              format: "Only .pkg files are allowed.",
            },
          },
          update: {
            success: "Firmware updated successfully.",
            fail: "Failed to update firmware.",
          },
          delete: {
            success: "Firmware deleted successfully.",
            fail: "Failed to delete firmware.",
          },
          download: {
            fail: "Failed to get firmware download URL.",
          },
          getInfo: {
            fail: "Failed to get firmware update info.",
          },
        },
        update: {
          success: "Firmware upgrade updated successfully.",
          fail: "Failed to update firmware upgrade.",
        },
        upgradeError: {
          "1001": "Authentication failed due to a device issue.",
          "1002": "Authentication failed due to a temporary account issue.",
          "2001": "Preparation failed due to a firmware API issue.",
          "2002":
            "Preparation failed due to a firmware API error. Additional error details may be available.",
          "3001": "Upload failed due to multiple possible causes.",
          "3002": "Upload failed due to multiple possible causes.",
          "3003":
            "Preparation failed due to an issue with the provided firmware file.",
          "536870914": "An unknown error occurred. Please try again.",
          "536870931":
            "The network connection to the node was lost. Please check your connection and try again.",
          "536870934": "The operation failed. Please try again.",
          "536870935":
            "The node is offline. Please check the device status and try again.",
          "536870938":
            "Invalid node. Please verify the selected device and try again.",
          "536870941": "The requested task does not exist.",
          "536870942": "No recording data is available.",
          "536870943":
            "Invalid parameters provided. Please check your input and try again.",
          "536870944":
            "Device currently does not allow upgrade, please try again later.",
          "536870945":
            "The device is busy and cannot process the request. Please try again later.",
          "536870947":
            "User does not exist. Please check the account information.",
          "536870948": "Incorrect password. Please try again.",
          "536870953": "You do not have permission to perform this action.",
          "536870960":
            "The system is busy and cannot process the request. Please try again later.",
          "536870961":
            "The file stream has ended due to network issues or file completion.",
          "536870965":
            "Failed to open audio. Please check the device or audio settings.",
          "536870977":
            "Invalid file type. Please upload a supported file format.",
          "536870978": "The file already exists.",
          "536870979": "The file does not exist.",
          "536870980": "Failed to create or open the file.",
          "536870982":
            "Device resource limit reached. Please free up resources and try again.",
          "536871004": "The maximum allowed quantity has been exceeded.",
          "536871011": "Session verification failed. Please log in again.",
          "536871024":
            "The device is already running the same version. Update is not required.",
          "536871030": "No disk detected. Please check the storage device.",
          "536871055": "Hash verification failed. The file may be corrupted.",
          "536871056": "Data verification failed. Please try again.",
          "536871057": "Failed to write the file.",
          "536871058": "Failed to read the file.",
          "536871059": "The specified channel does not exist.",
          "536871060": "The task already exists.",
        },
        errorCode: {
          "40001": "Firmware package not found.",
          "40003": "Firmware file not uploaded yet.",
          "40004": "File size or checksum mismatch.",
          "40005": "No fields to update.",
          "40006": "Firmware file is not ready to download.",
          "40007": "Firmware package already deleted.",
          "50011": "Firmware package not found.",
          "50012": "Only .pkg files are allowed.",
          "50021": "Failed to verify firmware upload.",
          "50022": "Failed to update firmware package.",
          "50023": "Failed to generate new upload URL.",
          "50024": "Failed to generate download URL.",
          "50025": "Failed to delete firmware package.",
          "90006": "Recorder communication failure.",
          "90013": "Firmware upgrade not supported.",
        },
      },
      email: {
        notify: {
          delete: {
            success: "Email history deleted successfully.",
            fail: "Failed to delete email history.",
          },
          schedule: {
            delete: {
              success: "Scheduled email deleted successfully.",
              fail: "Failed to delete scheduled email.",
            },
          },
        },
      },
      notice: {
        notify: {
          display: {
            update: {
              fail: "Failed to update notice display.",
            },
          },
          add: {
            success: "Notice added successfully.",
            fail: "Failed to add notice.",
          },
          update: {
            success: "Notice updated successfully.",
            fail: "Failed to update notice.",
          },
          delete: {
            success: "Notice deleted successfully.",
            fail: "Failed to delete notice.",
          },
        },
      },
    },
    dash: {
      notify: {
        missing: {
          update: {
            success: "Recorder location updated successfully.",
            fail: {
              address:
                "Failed to update recorder location. The address is incorrect.",
            },
          },
        },
      },
      widget: {
        update: {
          fail: "Failed to update layout.",
        },
      },
    },
    about: {
      notify: {
        tech: {
          send: {
            success: "Submission completed successfully.",
            fail: "Failed to submit.",
          },
        },
      },
    },
    contact: {
      get: {
        fail: "Failed to get contact info",
      },
    },
    passkey: {
      loginFailed: "Passkey login failed. Please enter your password.",
      setupFailed: "Passkey setup failed. Please try again.",
      passkeySetupSuccess:
        "Passkey setup successful. Please login with your email and password.",
    },
  },
  user: {
    permission: {
      manageAlertRules: "Manage Alert Rules",
      viewAlerts: "View Alerts",
      manageUsersAndGroups: "Manage Users and Groups",
      viewUsersAndGroups: "View Users and Groups",
      manageReportRules: "Manage Report Rules",
      viewReports: "View Reports",
      manageRecordersAndGroups: "Manage Recorders and Groups",
      viewRecordersAndGroups: "View Recorders and Groups",
      manageAccount: "Manage Organization",
      viewAccount: "View Organization",
      videoShare: "View",
      manageSubscription: "Manage Subscription",
      viewSubscription: "View Subscription",
      videoGuideSetting: "myDW Guide Settings",
      announcement: "Announcement",
      techSupport: "Tech Support",
      siteNotice: "Site Notice",
      emails: "Emails",
      myOrganization: "My Organization",
      manageBillingAndLicenses: "Manage Subscription",
      logging: "Logging",
      releaseNotes: "Release Notes",
      manageMaintenance: "Manage Device Maintenance",
    },
  },
  alert: {
    popup: {
      label: {
        confirm: {
          message: "Confirm the alert has been resolved?",
          check: "Don't ask again in this alert view",
        },
      },
    },
  },
  screenRecordingError: {
    media_aborted: {
      title: "Media aborted",
      description: "The screen is down.",
    },
    no_specified_media_found: {
      title: "No specified media found",
      description: "The selected screen could not be found.",
    },
    media_in_use: {
      title: "Media in use",
      description: "The screen or mic is being used elsewhere",
    },
    invalid_media_constraints: {
      title: "Invalid media constraints",
      description: "The selected screen or mic could not be found.",
    },
    no_constraints: {
      title: "No constraints",
      description: "The screen is not specified.'",
    },
    recorder_error: {
      title: "Recorder error",
      description: "An error occurred while recording the screen.",
    },
    permission_denied: {
      title: "Screen recording has been canceled",
      description: {
        chrome:
          "Please allow screen or microphone permission.\nClick the left side of the address bar. Then, change the settings.",
        edge: "Please allow screen or microphone permission.\nClick the left side of the address bar and change the settings.",
        firefox:
          "Please allow screen or microphone permission.\nClick the left side of the address bar. And change the settings.",
        safari:
          "Please allow screen or microphone permission.\nPreferences -> Websites -> Microphone -> change to ‘Ask’\nPreferences -> Websites -> Screen Sharing -> change to ‘Ask’",
      },
    },
  },
  PasskeyErrorCode: {
    "30004": "Rate limit exceeded.",
    "110001": "The browser does not support WebAuthn.",
    "110002": "Credential creation failed",
    "110003": "Credential verification failed",
    "110004": "Please try logging in via email or set up your passkey again.",
    "110005": "Passkey registration failed.",
    "110006": "Passkey registration successful.",
    "110007": "Passkey removal successful.",
    "110008": "Passkey removal failed.",
  },
  ServerErrorCode: {
    "1000": "This email is already registered",
    "1001": "This email is not registered.",
    "1002": "The password you entered is incorrect.",
    "1003": "The user has not accepted the invitation",
    "1004": "Authentication failed.",
    "1005": "User group not found.",
    "1006": "Phone number has not been verified.",
    "1007": "Phone number not found.",
    "1008":
      "If you are the only administrator, you can't deactivate. Invite or reassign a new user to be an administrator and try again.",
    "1009": "The default user group cannot be deleted.",
    "1010": "The token is not found.",
    "1011": "The token has expired.",
    "1012": "User must belong to at least one group.",
    "1013":
      "If you are the only administrator, you cannot deactivate. Invite or reassign a new user to be an administrator and try again.",
    "1014": "You don't have permission to delete users.",
    "1015": "DW Spectrum cloud email does not match the invited email.",
    "1019": "The user group name already exists.",
    "1020":
      "The update failed because there are no administrators in the organization. At least one user must be in the Administrator Group.",
    "1021": "Unable to send SMS for 2FA.",
    "1022": "Unable to send Email for 2FA.",
    "1023": "2FA verification failed.",
    "1024": "2FA code has expired. Please resend code and try again.",
    "1025": "The owner cannot be deleted.",
    "1026": "The owner must belong to an administrator group.",
    "1027": "You are not allowed to select apply all.",
    "1029": "Free trial email sent again.",
    "1030": "Verification failed. Please check your code.",
    "1031": "Your login code has expired.",
    "1032": "Invalid code. Please try again.",
    "1033": "Failed to register passkey.",
    "1034": "Passkey limit exceeded. You can only add up to 3 passkeys.",
    "3001": "Organization not found",
    "3002": "Cannot delete organization.",
    "3003": "Organization and user not found",
    "3004": "Invalid organization: Not allowed to register recorder.",
    "3005": "Invalid organization: Not applicable for license information.",
    "3006": "CP organization with EU/CP organization(s) cannot be deleted.",
    "3007": "EU organization with recorder(s) cannot be deleted.",
    "3008": "The organization name already exists.",
    "3009": "No Channel Partner found for Free Trial.",
    "3010": "Unable to send Free Trial email to the manager group.",
    "3019": "The organization has been disabled.",
    "3020": "The organization has been suspended.",
    "3021": "Your company already registered.",
    "5001": "Recorder not found",
    "5002": "Recorder and recorder group are empty.",
    "5003": "Recorder is already registered.",
    "5004": "Recorder group not found.",
    "5005": "Permission denied",
    "5006": "Recorder is already registered with another organization.",
    "5007": "System is already registered with another organization.",
    "5008": "P2P ID does not exist.",
    "5009": "Local spectrum information does not exist.",
    "5010": "Username or Password is incorrect.",
    "5011": "Local DW Spectrum connection failed.",
    "5012": "Local DW Spectrum connection timed out.",
    "5013": "DW Cloud connection failed.",
    "5014": "The user information of the DW Cloud system is different.",
    "5015": "System not found in DW Spectrum Cloud Account.",
    "5016": "The recorder group name already exists.",
    "6001":
      "The license value has changed. The license screen will be refreshed. Please try again.",
    "6002":
      "The license value has changed. The license screen will be refreshed. Please wait a moment and try again.",
    "6003": "Storage amount must be an integer.",
    "6004": "No subscription request found.",
    "7001": "Camera not found.",
    "7002": "Camera is already registered.",
    "8001": "Alert rule not found.",
    "8002": "System alert rule cannot be deleted.",
    "8003": "Performance alert rule cannot be deleted.",
    "8004": "Camera alert rule cannot be deleted.",
    "8005": "The Alert rule name already exists.",
    "9001": "Alert history not found.",
    "10001": "Already registered.",
    "11001": "Video Share not found.",
    "11002": "Video Share User not found.",
    "11003": "Video sharing has expired.",
    "11004": "Failed to register video share.",
    "11005": "Failed to obtain signed URL.",
    "11006": "Video share has been cancelled.",
    "12001": "Report not found.",
    "12002": "It's not a CVV report.",
    "12003": "The report name already exists.",
    "12107": "Subscription Key is not found.",
    "12109": "Subscription Key is already registered.",
    "20001": "AWS communication failed.",
    "30001": "DW Spectrum cloud users cannot change the email or password.",
    "31000": "Authentication denied. Try again in a minute",
    "30008":
      "Authentication information does not exist. Please contact your administrator.",
    "40001": "User Permission not found.",
    "40002": "This feature is available to DW organization only.",
    "50001": "Notice schedule is not registered.",
    "50002": "Email schedule is not scheduled.",
    "50003": "Scheduled Email Not Found.",
    "50004": "Email Not Found.",
    "50005": "Scheduled email job not found.",
    "50012": "Only .pkg files are allowed.",
    "50014": "Failed to generate firmware upload URL.",
    "50016":
      "An active firmware package for this device version and model already exists.",
    "60001": "Redis related task failed.",
    "70001": "Cloud Storage not found.",
    "70002": "Cloud Storage is full.",
    "80001": "Installation Report not found.",
    "80002": "Installation report of the cameras not found",
    "80003": "Installation Report updated successfully.",
    "80004": "Failed to update installation report.",
    "80005": "Failed to delete the report.",
    "90003": "Thumbnail not found.",
    "90004": "Thumbnail not found",
    "90005": "Thumbnail does not exist.",
    "90006": "Recorder communication failure.",
    "90007": "Camera is invalid.",
    "90008": "Camera is offline.",
    "90009": "Camera is unauthorized.",
    "90010": "Camera is not recording.",
    "90011": "Recorder is not responding.",
    "90012": "Recorder's auth fail.",
    "100000": "Failed file operation.",
    "100001": "Feature not supported on this system.",
    "100003": "Request to messenger failed",
    "100004": "Recorder authentication error.",
    "100005": "Recorder not responding",
    "100006": "Missing parameter(s) or invalid parameter values.",
    "100007": "Report has already been created.",
    "100008": "Agent failed to response.",
    "100009":
      "Cannot assign permissions that exceed the current authority of the group's creator.",
    "110000": "Request to DW Spectrum failed.",
    "110001": "File size exceeded the limit.",
    "111000": "Retry limit has been exceeded.",
    "120001": "Service is duplicated.",
    "120002": "Price tier is duplicated.",
    "121000": "Subscription not found.",
    "121003": "Key generation failed.",
    "121004": "There is no price information from the organization.",
    "121005": "There was an issue processing the payment.",
    "121006": "The process was halted due to an undefined key type.",
    "121007": "Subscription key is not found.",
    "121008": "Subscription key is not registered.",
    "121009": "Subscription key is already registered.",
    "121010": "Subscription type is undefined.",
    "121011": "Subscription type is already activated.",
    "121012": "Only EU organizations are searchable",
    "121013": "Only CP organizations are searchable",
    "121014": "Failed to send email.",
    "121015": "Failed to update price using Stripe API.",
    "121016": "Service price not found.",
    "121017": "Failed to update price.",
    "121018": "The registered key is not associated with the parent CP.",
    "121019": "Unable to retrieve CP information.",
    "121020": "Export failed while creating the file.",
    "121021": "Failed to confirm subscription request. ",
    invalid_grant: "Incorrect login credentials.",
  },
} as const;
